import React, { useState, useEffect } from 'react';

const AutoRefreshControl = ({ onRefresh }) => {
  const [interval, setInterval] = useState(30); // 기본 30초
  const [isAutoRefresh, setIsAutoRefresh] = useState(false);
  const [countdown, setCountdown] = useState(interval);

  useEffect(() => {
    let timer;
    if (isAutoRefresh) {
      setCountdown(interval);
      timer = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            onRefresh();
            return interval;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [isAutoRefresh, interval, onRefresh]);

  const handleIntervalChange = (e) => {
    const newInterval = parseInt(e.target.value);
    setInterval(newInterval);
    setCountdown(newInterval);
  };

  const handleToggleAutoRefresh = () => {
    setIsAutoRefresh(prev => !prev);
    if (!isAutoRefresh) {
      setCountdown(interval);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <select
        value={interval}
        onChange={handleIntervalChange}
        disabled={isAutoRefresh}
        style={{ padding: '5px' }}
      >
        <option value={10}>10초</option>
        <option value={30}>30초</option>
        <option value={60}>1분</option>
        <option value={300}>5분</option>
      </select>

      <button
        onClick={handleToggleAutoRefresh}
        style={{
          padding: '5px 15px',
          backgroundColor: isAutoRefresh ? '#ff4444' : '#4CAF50',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        {isAutoRefresh ? `자동 새로고침 중지 (${countdown}초)` : '자동 새로고침 시작'}
      </button>

      <button
        onClick={onRefresh}
        disabled={isAutoRefresh}
        style={{
          padding: '5px 15px',
          backgroundColor: '#2196F3',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: isAutoRefresh ? 'not-allowed' : 'pointer',
          opacity: isAutoRefresh ? 0.5 : 1
        }}
      >
        새로고침
      </button>
    </div>
  );
};

export default AutoRefreshControl;
